export const TRACKING_CHANNEL = 'wbm/People_Directory';
export const USER_BAG_FILTERS_ID = {
  city: 'city',
  jobTitle: 'jobTitle',
};

export const SEO_URL_META_DATA = 'https://www.xing.com/people/';
const PEOPLE_DIRECTORY_ROUTE = `/people/`;
const SLUG_REGEX = ':slug([a-zA-Z]+-[a-zA-Z]+)';
const SLUG_PAGE_REGEX = '-p:page([0-9]+)';

export const userBagUsernameRoutes = {
  USER_BAG_PAGE: `${PEOPLE_DIRECTORY_ROUTE}${SLUG_REGEX}/`,
  USER_BAG_PAGE_PAGINATED: `${PEOPLE_DIRECTORY_ROUTE}${SLUG_REGEX}${SLUG_PAGE_REGEX}/`,
};
